import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { User, UserPlus, KeyRound } from 'lucide-react';

const AdminInfoSection = ({ adminUsers, canEdit, onAddAdmin, onResetPassword }) => {
  return (
    <AccordionItem value="admin" className="bg-[#1E293B] border border-[#334155] rounded-lg overflow-hidden">
      <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-[#334155]/30" data-testid="admin-info-trigger">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#0EA5E9]/20 flex items-center justify-center">
            <User className="w-5 h-5 text-[#38BDF8]" />
          </div>
          <span className="text-lg font-semibold text-[#E2E8F0]" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Admin Info
          </span>
          <Badge variant="outline" className="ml-2 bg-[#334155] text-[#94A3B8] border-[#475569]">
            {adminUsers?.length || 0}
          </Badge>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-6 pb-4">
        {canEdit && (
          <div className="flex justify-end mb-4">
            <Button
              size="sm"
              onClick={onAddAdmin}
              className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white"
              data-testid="add-admin-button"
            >
              <UserPlus className="w-4 h-4 mr-1" />
              Add Admin
            </Button>
          </div>
        )}
        {adminUsers?.length > 0 ? (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="border-b border-[#334155] hover:bg-transparent">
                  <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Name</TableHead>
                  <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Email</TableHead>
                  <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Phone</TableHead>
                  {canEdit && (
                    <TableHead className="text-[#94A3B8] font-semibold text-xs uppercase tracking-wider">Actions</TableHead>
                  )}
                </TableRow>
              </TableHeader>
              <TableBody>
                {adminUsers.map((admin) => (
                  <TableRow key={admin._id} className="border-b border-[#334155]/50 hover:bg-[#334155]/20">
                    <TableCell className="text-[#E2E8F0] font-medium">
                      {admin.fullname || `${admin.firstname || ''} ${admin.lastname || ''}`.trim() || 'N/A'}
                    </TableCell>
                    <TableCell className="text-[#94A3B8]">{admin.email}</TableCell>
                    <TableCell className="text-[#94A3B8]">
                      {admin.phoneno ? `${admin.phonenoPrefix || ''} ${admin.phoneno}` : admin.phoneNumber || 'N/A'}
                    </TableCell>
                    {canEdit && (
                      <TableCell>
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={onResetPassword}
                          className="h-8 px-3 border-[#F59E0B]/30 text-[#FBBF24] hover:bg-[#F59E0B]/20"
                        >
                          <KeyRound className="w-3.5 h-3.5 mr-1" />
                          Reset Password
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : (
          <p className="text-[#64748B] text-center py-4">No admin users found for this shop. Click "Add Admin" to create one.</p>
        )}
      </AccordionContent>
    </AccordionItem>
  );
};

export default AdminInfoSection;
